import React, { useState, Suspense, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import "./App.scss";
import "./i18n";
import { t } from "i18next";
import PageLoadHandler from './components/PageLoad/PageLoadHandler'
function App() {
  const [isLogin, setIslogin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIslogin(true);
    }
  }, []);

  return (
    <Router basename=''>
      <ToastContainer />
      <Suspense fallback={<PageLoadHandler />}>
        <Routes />
      </Suspense>
    </Router>
  );
}
export default App;
